import React, { Component } from "react";
import { API_KEY } from "./config.js";
import MovieList from "./MovieList.js";
import Footer from "./Footer.js";
import "../tailwind.css";
import AppContext from "./GlobalContext";
import data from "./data.json";
export default class Homepage extends Component {
  static contextType = AppContext;
  componentDidMount() {
    this.fetchMovies();
    // this.fetchMoviesLocally();
  }
  // addLikesToMovies = (data) => {
  //   const { userFavoriteMovies } = this.context;
  //   // console.log("TCL: Homepage -> this.context", this.context);
  //   console.log("TCL: Homepage -> userFavoriteMovies", userFavoriteMovies);
  //   if (userFavoriteMovies) {
  //     const userLiked = Object.keys(userFavoriteMovies);
  //     console.log("TCL: Homepage -> userLiked", userLiked);
  //     data.forEach((movie) => {
  //       if (userLiked.includes(movie.id)) {
  //         movie.favorite = true;
  //       } else {
  //         movie.favorite = false;
  //       }
  //     });
  //   }
  //   return data;
  // };
  componentDidUpdate(res) {
    // console.log("TCL: Homepage -> componentDidUpdate -> res", res);
  }
  fetchMoviesLocally = () => {
    setTimeout(() => {
      const movies = data.results;
      this.setState({ movies, isLoading: false });
      // throw new Error("as");
    }, 0);
  };
  state = {
    isLoading: true,
    totalMovies: 200,
    currentPage: 1,
    items: 20,
    movies: [],
    error: false,
  };

  fethMoreMovies = () => {
    // console.log("TCL: fethMoreMovies -> fethMoreMovies");
    this.setState((prevState) => {
      return { currentPage: prevState.currentPage + 1 };
    });
    setTimeout(() => {
      this.fetchMovies();
    }, 1500);
  };
  fetchMovies = async () => {
    const URL = `https://api.themoviedb.org/3/discover/movie?api_key=${API_KEY}&language=en-US&sort_by=popularity.desc&include_adult=false&include_video=false&page=${this.state.currentPage}`;
    fetch(URL)
      .then((res) => res.json())
      .then((data) => {
        this.setState((prevState) => {
          const newMovies = prevState.movies.concat(data.results);
          return { movies: newMovies, isLoading: false };
        });
      })
      .catch((err) => {
        this.setState({ error: true });
      });
  };
  render() {
    // console.log("TCL: Homepage -> contextType ", this.context);

    const { movies, isLoading, totalMovies, error } = this.state;
    return (
      <React.Fragment>
        <MovieList
          data={[...movies]}
          heading="TRENDING MOVIES"
          loading={isLoading}
          error={error}
          items={movies.length}
          fetchMoreMovies={this.fethMoreMovies}
          totalMovies={totalMovies}
        />

        {movies.length <= totalMovies ? <Footer /> : null}
      </React.Fragment>
    );
  }
}
